export const iconFontAwesomeMediaplaybackCompress = (
	<i className="fa-solid fa-compress"></i>
);
